import { Injectable } from '@angular/core';
import { ApiService } from '@client/app/services/api/api-service/api.service';
import { RequestParamsType } from '@monsido/ng2/external/http/options';
import { NotificationType } from '@client/app/feature-modules/navigation/notifications/notifications.types';

@Injectable({ providedIn: 'root' })
export class NotificationsRepoService {
    constructor (
        private readonly apiService: ApiService,
    ) {}

    getAll (params: RequestParamsType): Promise<NotificationType[]> {
        return this.apiService.get<NotificationType[]>('notifications', params);
    }
}
